import { render } from "./ListaAziendeGruppo.vue?vue&type=template&id=b61512ec&ts=true"
import script from "./ListaAziendeGruppo.vue?vue&type=script&lang=ts"
export * from "./ListaAziendeGruppo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__